export type PrivySession = {
  isActive: () => boolean;
  logout: () => Promise<void>;
};

let pendingLogout: Promise<void> | null = null;

// Privy answers a logout without a live session with 401, and a second overlapping logout replays a
// revoked token; so skip the call when signed out and let concurrent callers share the one in flight.
export const clearPrivySession = (session: PrivySession): Promise<void> => {
  if (pendingLogout) {
    return pendingLogout;
  }

  if (!session.isActive()) {
    return Promise.resolve();
  }

  pendingLogout = session.logout().finally(() => {
    pendingLogout = null;
  });

  return pendingLogout;
};

export const clearPrivySessionBestEffort = (session: PrivySession): Promise<void> =>
  clearPrivySession(session).catch(() => undefined);
